import styles from "./TopMenuList.module.css";
import {Link} from "react-router-dom";

/**
 * @author yjkim
 * @date 2022-09-21 13:28
 * @remark 헤더 메뉴의 메뉴 리스트
 * @param TopMenuListProps
 *       text (string) : 표시되는 텍스트
 *       link (string) : 클릭시 연결되는 url
 * @returns TopMenuList JSX.Element 
 */

export interface TopMenuListProps{
    text : string
    link : string
}

export function TopMenuList (props : any){
    return (
        <li>
            <Link to={props.link} className={styles.headerATag}>{props.text}</Link>
        </li>
    )
}
